import { render } from "./FormHeader.vue?vue&type=template&id=0e0d4820&scoped=true&lang=pug"
import script from "./FormHeader.vue?vue&type=script&lang=js"
export * from "./FormHeader.vue?vue&type=script&lang=js"

import "./FormHeader.vue?vue&type=style&index=0&id=0e0d4820&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e0d4820"]])

export default __exports__